// src/locales/English/en.faq.ts

const faq = {
  faq: {
    meta: {
      title: "Frequently Asked Questions",
      subtitle:
        "Find quick answers about accounts, posting, location, privacy, chat, safety, advertising, and troubleshooting.",
      back: "Back",
      overviewTitle: "Help & Support",
      searchPlaceholder: "Search FAQ",
    },

    sidebar: {
      feedsPosting: "Feeds & Posting",
      locationPrivacy: "Location & Privacy",
      chatEncryption: "Chat & Encryption",
      accountSecurity: "Account & Security",
      followingLikes: "Likes, Following & Notifications",
      safetyReporting: "Safety, Reporting & Moderation",
      adsBilling: "Ads & Billing",
      troubleshooting: "Troubleshooting",
    },

    overview: {
      whatIsGallery: "What is the Gallery?",
      myPreferencesFeed: "What is My Feed?",
      myLikesFeed: "What is My Likes?",
      musicPostFeed: "What is Music Post Feed?",
      locationPostFeed: "What is Location Post Feed?",
      howManyMedia: "How many photos/videos can I include in one post?",
      postOrder: "How are posts ordered in the Gallery?",
      changeLocationFeed: "Can I change the location of my Gallery feed?",
      presentationMode: "What is Presentation mode?",
      hiddenHashtags: "What are Hidden Hashtags?",
      hiddenHashtagsVisibility: "Do hidden hashtags appear on posts?",
      whyNoHiddenHashtag: "Why can't I find posts for a hashtag?",
      locationChangePost: "Can I change the location of a post after publishing?",
      musicOnPosts: "Can I change music to my videos after posting?",
      addMusicPost: "How can I add music to a post?",
      filters: "Can I apply filters to photos/videos?",
      editAfterPost: "Can I edit a post after publishing?",
      uploadFailed: "My upload fails or gets stuck. What can I do?",
      videoFormat: "What video format works best?",
      whyPostNotVisible: "Why can’t I see my post in the Gallery?",
      seeOwnPosts: "Where do I see my own posts?",
      removeMediaBeforePost: "Can I remove a media item before I publish?",

      locationNeeded: "Why does Elnydo request location?",
      changeLocationVsPosting: "Does changing my feed location also change my posting location?",
      whatLocationStored: "What location data is stored with my post?",
      turnOffLocation: "Can I use Elnydo with location turned off?",
      vpnLocation: "Does a VPN change my post’s location?",
      whoSeesLocation: "Who can see my post location?",
      hideLikeActivity: "Can I hide my likes or activity?",
      profilePrivacy: "Can I make my profile private?",
      blockedPrivacy: "Does blocking someone hide my content from them?",
      dataMinimization: "Does Elnydo sell my data or track me for ads?",
      reportingPrivacy: "Are reports anonymous?",
      deleteLocationData: "If I delete a post, does the location tag disappear too?",

      startChat: "How do I start a conversation?",
      whoCanMessageMe: "Who can send me messages?",
      isChatE2ee: "Is chat end-to-end encrypted (E2EE)?",
      chatMetadata: "What metadata exists even with E2EE?",
      canElnydoReadChat: "Can Elnydo read my chat messages?",
      sendMediaChat: "Can I send photos/videos in chat?",
      deleteChatMessage: "Can I delete a chat message?",
      lostDeviceChat: "What happens if I lose my device?",
      messageNotDelivered: "Why are my messages not delivering?",
      blockedChat: "Can I chat with a user I blocked?",
      groupChats: "Does Elnydo support group chats?",
      screenshots: "Does Elnydo prevent screenshots in chat?",
      chatSearch: "Can I search within chats?",
      chatAttachmentsFail: "Why does sending media fail in chat?",

      forgotPassword: "I forgot my password. What should I do?",
      changeEmail: "Can I change my account email?",
      changePassword: "How do I change my password?",
      reauthWhy: "Why does Elnydo ask me to re-authenticate?",
      logoutEverywhere: "Can I log out of all devices?",
      suspiciousLogin: "I see suspicious activity. What should I do?",
      twoFactor: "Does Elnydo support 2FA?",
      accountDeletion: "How do I delete my account?",
      anonymizedWhat: "What does 'anonymized' mean when I delete my account?",
      blockedUsersList: "Where do I see users I blocked?",
      usernameChange: "Can I change my profile name?",
      deviceChange: "What happens if I switch phones?",

      likeUnlike: "How do I like or unlike a post?",
      seeLikedPosts: "Where can I see posts I liked?",
      followUnfollow: "How do I follow or unfollow someone?",
      followersFollowing: "What is the difference between Followers and Following?",
      followNotification: "Do users get notified when I follow them?",
      likeNotification: "Do users get notified when I like their post?",
      notificationSettings: "Can I turn off notifications?",
      notificationsNotWorking: "Why am I not receiving notifications?",
      muteUser: "Can I mute someone without blocking them?",
      visibilityFollowing: "Does following change what I see in the Gallery?",

      whenBlock: "When should I block a user?",
      whenReport: "When should I report a post or account?",
      whatHappensReport: "What happens after I report something?",
      appeal: "Can I appeal a moderation decision?",
      falseReport: "What if someone falsely reports me?",
      scams: "How do I avoid scams on Elnydo?",
      dangerEmergency: "What if someone is in immediate danger?",
      copyright: "What about copyright and reposting content?",
      hateSpeech: "Does Elnydo allow hate speech or harassment?",
      privacyViolations: "What if someone shares my private information?",

      adsRequired: "Do I need ads to use Elnydo?",
      createAd: "How do I create an ad campaign?",
      adTargeting: "How does ad targeting work?",
      adReviewTime: "How long does ad review take?",
      adRejected: "Why was my ad rejected?",
      billingWhenCharged: "When do I get charged for ads?",
      adSpendNotDelivering: "My ad is not spending or delivering. Why?",
      adCreativeBest: "What makes a good ad creative?",
      refunds: "Do you offer refunds for ads?",
      invoices: "Where do I find invoices?",

      appCrashes: "The app crashes or freezes. What should I do?",
      cantLogin: "I can’t log in. What can cause this?",
      slowFeed: "The Gallery feels slow. How can I improve it?",
      noSound: "My video has no sound. Why?",
      cameraPermission: "Camera or photos permission is missing. How do I fix it?",
      locationPermission: "Location permission is missing. How do I fix it?",
      notificationsDisabled: "Notifications are enabled in the app but I still don’t get them.",
      blockedContent: "Why do I see fewer posts than my friend in the same city?",
      profileNotUpdating: "My profile changes don’t show up.",
      contactSupportWhen: "When should I contact support?",
    },

    sections: {

//////////////////////////////////////
/////////Feeds & Posting//////////////
//////////////////////////////////////

      "what-is-gallery": {
        title: "What is Gallery?",
        body: [
          {
            type: "paragraph",
            text: "Gallery is Elnydo's main feed where you browse posts, photos, and videos from your current location or a selected location.",
          },
        ],
      },

      "my-preferences-feed": {
  title: "What is My Feed?",
  body: [
    {
      type: "paragraph",
      text: "My Feed shows posts from profiles you follow. It helps you quickly see new content from people and profiles you are interested in.",
    },
  ],
},

"my-likes-feed": {
  title: "What is My Likes feed?",
  body: [
    {
      type: "paragraph",
      text: "My Likes shows posts you have liked. This makes it easier to find content again without searching for it manually.",
    },
  ],
},


"add-music-post": {
  title: "How can I add music to a post?",
  body: [
    {
      type: "paragraph",
      text: "Music can only be added to video posts. During the upload process, select Add Music if you want to associate a music track with your video. Other users can then open the music title to discover additional posts using the same track.",
    },
    {
      type: "note",
      text: "If your video already contains music before uploading, you are responsible for ensuring that you have the necessary rights, permissions, or licenses to use that music.",
    },
  ],
},


"music-post-feed": {
  title: "What is Music Post Feed?",
  body: [
    {
      type: "paragraph",
      text: "Music Post Feed shows posts that use the same selected music track. When you open a music feed (by clicking on a music title), you can discover other posts connected to that track.",
    },
  ],
},

"location-post-feed": {
  title: "What is Location Post Feed?",
  body: [
    {
      type: "paragraph",
      text: "Location Post Feed shows posts from the same location. It helps you explore more content connected to a specific city or country.",
    },
  ],
},

      "how-many-media": {
        title: "How many photos/videos can I include in one post?",
        body: [
          {
            type: "paragraph",
            text: "A single post can contain up to 8 media items, including a maximum of 1 video.",
          },
        ],
      },

      "post-order": {
        title: "How are posts ordered in the Gallery?",
        body: [
          {
            type: "paragraph",
            text: "Within each location scope, posts are typically shown newest first, sorted by publishing time.",
          },
        ],
      },

      "change-location-feed": {
        title: "Can I change the location of my Gallery feed?",
        body: [
          {
            type: "paragraph",
            text: "Yes. You can use Change Location to browse another city or country. This affects only what you see in the feed and does not change where your posts are tagged.",
          },
        ],
      },

      "hidden-hashtags": {
        title: "What are Hidden Hashtags?",
        body: [
          {
            type: "paragraph",
            text: "Hidden Hashtags help categorize posts without displaying hashtags publicly. They can be added when creating or editing a post and can later be searched to discover related content. ",
          },
        ],
      },

      "hidden-hashtags-visibility": {
        title: "Do hidden hashtags appear on posts?",
        body: [
          {
            type: "paragraph",
            text: "Hidden hashtags are used for categorization and search but are not displayed publicly on posts.",
          },
        ],
      },

      "why-no-hidden-hashtag": {
        title: "Why can't I find posts for a hashtag?",
        body: [
          {
            type: "paragraph",
            text: "No posts may currently exist for that hashtag, the hashtag may be misspelled, posts may have been removed, or the content may not be visible due to visibility settings.",
          },
        ],
      },



      "presentation-mode": {
        title: "What is Presentation mode?",
        body: [
          {
            type: "paragraph",
            text: "Presentation mode is the focused viewer for a post. It shows one media item per page so you can navigate left or right with arrows and close the viewer with the close button or Escape.",
          },
        ],
      },

      "music-on-posts": {
        title: "Can I change music to my videos after posting?",
        body: [
          {
            type: "paragraph",
            text: "No, adding music to a video after posting is not possible",
          },
        ],
      }, 

      "filters": {
        title: "Can I apply filters to photos/videos?",
        body: [
          {
            type: "paragraph",
            text: "Yes, if filters are available in your uploader. Apply the filter during preview before publishing.",
          },
        ],
      },

      "edit-after-post": {
        title: "Can I edit a post after publishing?",
        body: [
          {
            type: "paragraph",
            text: "After publishing, you can edit certain post information such as hidden hashtags and delete media items. Uploaded media files themselves cannot be replaced and no additional media can be added.",
          },
        ],
      },

       "location-change-post": {
        title: "Can I change the location of a post after publishing?",
        body: [
          {
            type: "paragraph",
            text: "No. A post's location cannot be changed after publishing. Posts use the location associated with the post when it is created.",
          },
        ],
      },

      "upload-failed": {
        title: "My upload fails or gets stuck. What can I do?",
        body: [
          {
            type: "bullets",
            items: [
              "Try switching networks, for example from Wi-Fi to mobile data or the other way around.",
              "Reduce the file size before uploading.",
              "Make sure the app has the required permissions.",
              "Retry the upload after checking your connection.",
              "Large or long videos may fail more often.",
            ],
          },
        ],
      },

      "video-format": {
        title: "What video format works best?",
        body: [
          {
            type: "paragraph",
            text: "For reliability, use common optimized formats such as MP4/H.264. Extremely high-bitrate files or unusual codecs can cause upload or playback issues.",
          },
        ],
      },

      "why-post-not-visible": {
        title: "Why can’t I see my post in the Gallery?",
        body: [
          {
            type: "bullets",
            items: [
              "Check your post visibility settings.",
              "Refresh the feed.",
              "Confirm the post finished uploading.",
              "Make sure you are browsing the correct location scope.",
            ],
          },
        ],
      },

      "see-own-posts": {
        title: "Where do I see my own posts?",
        body: [
          {
            type: "paragraph",
            text: "Your posts appear on your profile and can also appear in the Gallery based on their tagged location and your visibility settings.",
          },
        ],
      },

      "remove-media-before-post": {
        title: "Can I remove a media item before I publish?",
        body: [
          {
            type: "paragraph",
            text: "Yes. In the preview step you can typically remove individual media items or reset the selection before publishing.",
          },
        ],
      },


//////////////////////////////////
//////Location & Privacy//////////
/////////////////////////////////

      "location-needed": {
        title: "Why does Elnydo request location?",
        body: [
          {
            type: "paragraph",
            text: "Location is used to tag posts with a city or country and to show location-based posts in the Gallery. Location helps show relevant content from the area around you.",
          },
        ],
      },

      "change-location-vs-posting": {
        title: "Does changing my feed location also change my posting location?",
        body: [
          {
            type: "paragraph",
            text: "No. Change Location affects browsing only. Posting uses the device’s current fetched location at the time you upload.",
          },
        ],
      },

      "what-location-stored": {
        title: "What location data is stored with my post?",
        body: [
          {
            type: "paragraph",
            text: "Posts are stored with a derived city and country tag.",
          },
        ],
      },

            "turn-off-location": {
        title: "Can I use Elnydo with location turned off?",
        body: [
          {
            type: "paragraph",
            text: "Some features may be limited. You may still browse content, but posting and location-based discovery may not function correctly without location access.",
          },
        ],
      },

      "vpn-location": {
        title: "Does a VPN change my post’s location?",
        body: [
          {
            type: "paragraph",
            text: "No. Elnydo uses the device location when creating a post. A VPN may affect your network routing but does not determine the post location.",
          },
        ],
      },

      "who-sees-location": {
        title: "Who can see my post location?",
        body: [
          {
            type: "paragraph",
            text: "Users can generally see the city or location tag associated with your post. Exact coordinates are not displayed.",
          },
        ],
      },

      "post-wo-location": {
        title: "Can I post without a location?",
        body: [
          {
            type: "paragraph",
            text: "No. Posts require a location so they can be associated with the correct location feed and discovery features.",
          },
        ],
      },




      "profile-privacy": {
        title: "Can I make my profile private?",
        body: [
          {
            type: "paragraph",
            text: "Elnydo does not currently offer private profiles. You can deactivate your account, hide your own posts, or block specific users. Public posts may still be visible to other users unless hidden or removed.",
          },
        ],
      },

      "blocked-privacy": {
        title: "Does blocking someone hide my content from them?",
        body: [
          {
            type: "paragraph",
            text: "Yes. Blocking prevents the blocked user from messaging you, following you, and viewing your profile and content where blocking is enforced.",
          },
        ],
      },

      "data-minimization": {
        title: "Does Elnydo sell my data or track me for ads?",
        body: [
          {
            type: "paragraph",
            text: "Generally no. Elnydo is designed around data minimization principles. For details, refer to the Data Protection Guideline and Privacy Policy.",
          },
        ],
      },

      "reporting-privacy": {
        title: "Are reports anonymous?",
        body: [
          {
            type: "paragraph",
            text: "Reports are reviewed internally. Reported users generally do not receive information about who submitted a report.",
          },
        ],
      },

      "delete-location-data": {
        title: "If I delete a post, does the location tag disappear too?",
        body: [
          {
            type: "paragraph",
            text: "Yes. When a post is deleted, its associated location tag is removed from public visibility together with the post.",
          },
        ],
      },

////////////////////////////////////////
///////////Chat & Encryption////////////
////////////////////////////////////////

"start-chat": {
  title: "How do I start a conversation?",
  body: [
    {
      type: "paragraph",
      text: "You can start a conversation from a user's profile or directly from one of their posts.",
    },
    {
      type: "steps",
      items: [
        "Open the user's profile or post.",
        "Select the Chat button.",
        "Type your message.",
        "Send the message to start the conversation.",
      ],
    },
  ],
},

"who-can-message-me": {
  title: "Who can send me messages?",
  body: [
    {
      type: "paragraph",
      text: "Any registered Elnydo user can start a conversation with another user by using the Chat button on a profile or post, unless messaging is restricted due to blocking.",
    },
    {
      type: "bullets",
      items: [
        "Users you follow can message you.",
        "Users who follow you can message you.",
        "Users do not need to follow each other to start a conversation.",
        "Blocked users cannot send you messages.",
        "You cannot send messages to users you have blocked.",
      ],
    },
  ],
},

  "is-chat-e2ee": {
  title: "Is chat end-to-end encrypted (E2EE)?",
  body: [
    {
      type: "paragraph",
      text: "Yes. Elnydo uses end-to-end encryption to help protect message contents. The system is designed so that message contents are intended to be accessible only to conversation participants, although no security measure can guarantee absolute security in all circumstances.",
    },
  ],
},

      "chat-metadata": {
        title: "What metadata exists even with E2EE?",
        body: [
          {
            type: "bullets",
            items: [
              "Sender and recipient identifiers.",
              "Message delivery timestamps.",
              "Technical delivery status information.",
              "Device synchronization information where required.",
            ],
          },
        ],
      },

      "can-elnydo-read-chat": {
        title: "Can Elnydo read my chat messages?",
        body: [
          {
            type: "paragraph",
            text: "No. Elnydo cannot read the contents of end-to-end encrypted messages. However, limited technical metadata such as sender information, recipient information, and delivery timestamps may still be processed to operate the service.",
          },
        ],
      },

      "send-media-chat": {
        title: "Can I send photos/videos in chat?",
        body: [
          {
            type: "paragraph",
            text: "No. Chat currently supports text messages only.",
          },
        ],
      },

      "delete-chat-message": {
        title: "Can I delete a chat message?",
        body: [
          {
            type: "paragraph",
            text: "Yes. When you delete a message you sent, it is removed from the conversation for all participants.",
          },
        ],
      },

      "lost-device-chat": {
        title: "What happens if I lose my device?",
        body: [
          {
            type: "bullets",
            items: [
              "Change your password immediately.",
              "Log out from all devices.",
              "Enable 2FA if available.",
              "Contact support if you suspect unauthorized access.",
            ],
          },
        ],
      },

      "message-not-delivered": {
        title: "Why are my messages not delivering?",
        body: [
          {
            type: "bullets",
            items: [
              "The recipient may be offline.",
              "The recipient may have blocked you.",
              "Your connection may be unstable.",
              "The chat service may be temporarily unavailable.",
            ],
          },
        ],
      },

      "blocked-chat": {
        title: "Can I chat with a user I blocked?",
        body: [
          {
            type: "paragraph",
            text: "No. Blocking prevents messaging and most direct interactions between users.",
          },
        ],
      },

      "group-chats": {
        title: "Does Elnydo support group chats?",
        body: [
          {
            type: "paragraph",
            text: "No. Elnydo currently supports one-to-one conversations only.",
          },
        ],
      },

      "screenshots": {
        title: "Does Elnydo prevent screenshots in chat?",
        body: [
          {
            type: "paragraph",
            text: "No. Users should assume that content displayed on a device may be captured by screenshots or external devices.",
          },
        ],
      },




      /////////////////////////////////////////////////
      ////////////Likes, Following & Notification/////////
      ////////////////////////////////////////////////////

      "like-unlike": {
        title: "How do I like or unlike a post?",
        body: [
          {
            type: "paragraph",
            text: "Open a post and click or tap the Like button. Selecting it again removes your like.",
          },
        ],
      },

      "see-liked-posts": {
        title: "Where can I see posts I liked?",
        body: [
          {
            type: "paragraph",
            text: "Posts you liked can be viewed from your profile in the My Likes section.",
          },
        ],
      },

      "follow-unfollow": {
        title: "How do I follow or unfollow someone?",
        body: [
          {
            type: "paragraph",
            text: "Visit a user's profile and select Follow. To stop following, return to the profile and select Unfollow.",
          },
        ],
      },

      "followers-following": {
        title: "What is the difference between Followers and Following?",
        body: [
          {
            type: "bullets",
            items: [
              "Followers are users who follow your profile.",
              "Following are users whose profiles you follow.",
              "Both lists are available from your profile.",
            ],
          },
        ],
      },

      "follow-notification": {
        title: "Do users get notified when I follow them?",
        body: [
          {
            type: "paragraph",
            text: "Yes. Users receive a notification when someone follows their profile.",
          },
        ],
      },

      "like-notification": {
        title: "Do users get notified when I like their post?",
        body: [
          {
            type: "paragraph",
            text: "Yes. Users receive a notification when someone likes their post.",
          },
        ],
      },

      "notification-settings": {
        title: "Can I turn off notifications?",
        body: [
          {
            type: "paragraph",
            text: "Yes. Notification preferences can be adjusted in Account Settings.",
          },
        ],
      },

      "notifications-not-working": {
        title: "Why am I not receiving notifications?",
        body: [
          {
            type: "bullets",
            items: [
              "Verify notifications are enabled in Elnydo.",
              "Check your device notification permissions.",
              "Disable battery-saving restrictions if necessary.",
              "Sign out and sign in again.",
            ],
          },
        ],
      },

      "mute-user": {
        title: "Can I mute someone without blocking them?",
        body: [
          {
            type: "paragraph",
            text: "If mute functionality is available, you can reduce notifications and visibility from a user without blocking them completely.",
          },
        ],
      },

      "visibility-following": {
        title: "Does following change what I see in the Gallery?",
        body: [
          {
            type: "paragraph",
            text: "Following a user adds their posts to My Feed. Gallery and location-based feeds continue to show content based on location and other available platform features.",
          },
        ],
      },


      /////////////////////////////////////////
      /////////////Account & Security//////////
      /////////////////////////////////////////

      "forgot-password": {
        title: "I forgot my password. What should I do?",
        body: [
          {
            type: "steps",
            items: [
              "Open the login page.",
              "Click Forgot Password.",
              "Enter your registered email address.",
              "Follow the instructions in the reset email.",
              "Create a new secure password.",
            ],
          },
        ],
      },

      "change-email": {
        title: "Can I change my account email?",
        body: [
          {
            type: "paragraph",
            text: "Yes. You can change your email address in Account Settings. The new email address must be verified with a 6-digit code sent to the new email address before the change becomes active.",
          },
        ],
      },

      "change-password": {
        title: "How do I change my password?",
        body: [
          {
            type: "steps",
            items: [
              "Open Account Settings.",
              "Select Change Password.",
              "Enter your current password.",
              "Enter a new password.",
              "Confirm and save the changes.",
            ],
          },
        ],
      },

      "reauth-why": {
        title: "Why does Elnydo ask me to re-authenticate?",
        body: [
          {
            type: "paragraph",
            text: "Sensitive actions such as changing your email address, password, deleting your account, or adjusting security settings may require re-authentication for security reasons.",
          },
        ],
      },

      "logout-everywhere": {
        title: "Can I log out of all devices?",
        body: [
          {
            type: "paragraph",
            text: "Yes. You can use Logout From All Devices in Security in Settings to terminate active sessions.",
          },
        ],
      },

      "suspicious-login": {
        title: "I see suspicious activity. What should I do?",
        body: [
          {
            type: "steps",
            items: [
              "Change your password immediately.",
              "Enable two-factor authentication.",
              "Log out from all devices.",
              "Review recent account activity.",
              "Contact support if needed.",
            ],
          },
        ],
      },

    "two-factor": {
  title: "Does Elnydo support 2FA?",
  body: [
    {
      type: "paragraph",
      text: "Yes. Two-factor authentication (2FA) can be enabled in Security Settings. When enabled, a verification code sent to your email address is required in addition to your password when signing in.",
    },
  ],
},

      "account-deletion": {
        title: "How do I delete my account?",
        body: [
          {
            type: "paragraph",
            text: "Account deletion can be started from Data & Privacy in Settings. You will be asked to verify the request using a code sent to your email address before the account is permanently deleted.",
          },
        ],
      },

      "anonymized-what": {
        title: "What does 'anonymized' mean when I delete my account?",
        body: [
          {
            type: "paragraph",
            text: "Anonymization means that identifying information is removed or disconnected from remaining records so they can no longer be linked back to you.",
          },
        ],
      },

      "blocked-users-list": {
        title: "Where do I see users I blocked?",
        body: [
          {
            type: "paragraph",
            text: "Blocked users can be reviewed and managed in Profile Management in Settings.",
          },
        ],
      },

      "username-change": {
        title: "Can I change my profile name?",
        body: [
          {
            type: "paragraph",
            text: "No, changing Profile Name is not possible after registration.",
          },
        ],
      },

      "device-change": {
        title: "What happens if I switch phones?",
        body: [
          {
            type: "paragraph",
            text: "Simply install Elnydo on your new device and sign in.",
          },
        ],
      },



      ///////////////////////////////////////////////////////////
      //////////////////Safety, Reporting & Moderation///////////
      ///////////////////////////////////////////////////////////

            "when-block": {
        title: "When should I block a user?",
        body: [
          {
            type: "paragraph",
            text: "You should block a user if they harass you, send unwanted messages, impersonate someone, spam, or make you feel unsafe while using the platform.",
          },
          {
            type: "bullets",
            items: [
              "Harassment or bullying.",
              "Repeated unwanted contact.",
              "Spam or scams.",
              "Impersonation attempts.",
              "Threatening or abusive behavior.",
            ],
          },
        ],
      },

      "when-report": {
        title: "When should I report a post or account?",
        body: [
          {
            type: "paragraph",
            text: "Report content or users that violate platform rules, applicable laws, or community standards.",
          },
          {
            type: "bullets",
            items: [
              "Hate speech or harassment.",
              "Violence or threats.",
              "Scams or fraudulent activity.",
              "Copyright violations.",
              "Sharing private information without consent.",
              "Illegal content.",
            ],
          },
        ],
      },

      "what-happens-report": {
        title: "What happens after I report something?",
        body: [
          {
            type: "paragraph",
            text: "Reports are reviewed by moderation systems and, where necessary, by human reviewers.",
          },
          {
            type: "bullets",
            items: [
              "The report is evaluated against platform policies.",
              "Additional information may be reviewed.",
              "Content may be restricted, removed, or left unchanged.",
              "Accounts may receive warnings or restrictions.",
            ],
          },
        ],
      },

      appeal: {
        title: "Can I appeal a moderation decision?",
        body: [
          {
            type: "paragraph",
            text: "Yes. If an appeal process is available, you can request a review of moderation actions that affect your account or content.",
          },
        ],
      },

      "false-report": {
        title: "What if someone falsely reports me?",
        body: [
          {
            type: "paragraph",
            text: "Reports are reviewed based on evidence and policy compliance. A report alone does not automatically result in penalties.",
          },
          {
            type: "note",
            text: "False or abusive reporting may itself violate platform policies.",
          },
        ],
      },

      scams: {
        title: "How do I avoid scams on Elnydo?",
        body: [
          {
            type: "bullets",
            items: [
              "Do not share passwords or verification codes.",
              "Be cautious of offers that seem too good to be true.",
              "Verify identities before sending money or personal information.",
              "Report suspicious messages or accounts.",
              "Use only official platform communication channels.",
            ],
          },
        ],
      },

      "danger-emergency": {
        title: "What if someone is in immediate danger?",
        body: [
          {
            type: "note",
            text: "Elnydo is not an emergency service.",
          },
          {
            type: "paragraph",
            text: "If someone is in immediate danger or requires urgent assistance, contact local emergency services or the appropriate authorities immediately.",
          },
        ],
      },

      copyright: {
        title: "What about copyright and reposting content?",
        body: [
          {
            type: "paragraph",
            text: "Only upload or share content that you own or have permission to use.",
          },
          {
            type: "bullets",
            items: [
              "Do not upload copyrighted material without permission.",
              "Respect intellectual property rights.",
              "Credit alone does not replace permission.",
              "Repeated copyright violations may result in account restrictions.",
            ],
          },
        ],
      },

      "hate-speech": {
        title: "Does Elnydo allow hate speech or harassment?",
        body: [
          {
            type: "paragraph",
            text: "No. Hate speech, harassment, discrimination, threats, and targeted abuse are not permitted on the platform.",
          },
          {
            type: "note",
            text: "Violations may result in content removal, account restrictions, or permanent account actions.",
          },
        ],
      },

      "privacy-violations": {
        title: "What if someone shares my private information?",
        body: [
          {
            type: "paragraph",
            text: "Report the content immediately. Sharing personal information without consent may violate platform rules and privacy protections.",
          },
          {
            type: "bullets",
            items: [
              "Report the content.",
              "Block the responsible account if necessary.",
              "Contact support for serious cases.",
              "Contact authorities if personal safety is at risk.",
            ],
          },
        ],
      },


      //////////////////////////////////////////////////////////////
      ///////////////////////////Ads & Billing//////////////////////
      //////////////////////////////////////////////////////////////

      "ads-required": {
        title: "Do I need ads to use Elnydo?",
        body: [
          {
            type: "paragraph",
            text: "No. Elnydo can be used without creating advertisements. Advertising is optional and intended for users, creators, organizations, or businesses who want to increase visibility for content, products, services, or events.",
          },
        ],
      },

      "create-ad": {
        title: "How do I create an ad campaign?",
        body: [
          {
            type: "steps",
            items: [
              "Open the Advertisement Manager.",
              "Click Create Campaign.",
              "Enter a campaign name.",
              "Select your target location and audience settings.",
              "Upload your image or video.",
              "Add your destination URL and call-to-action button.",
              "Set your budget and campaign duration.",
              "Review the campaign and submit it for approval.",
            ],
          },
        ],
      },

      "ad-targeting": {
        title: "How does ad targeting work?",
        body: [
          {
            type: "paragraph",
            text: "Advertisers can define who should see their ads using available targeting options.",
          },
          {
            type: "bullets",
            items: [
              "Location-based targeting.",
              "Language targeting.",
              "Age restrictions where applicable.",
              "Interest or category targeting if available.",
            ],
          },
        ],
      },

      "ad-review-time": {
        title: "How long does ad review take?",
        body: [
          {
            type: "paragraph",
            text: "Advertisements are reviewed before publication to ensure compliance with platform policies and legal requirements.",
          },
          {
            type: "bullets",
            items: [
              "Most reviews are completed within a short period.",
              "Complex campaigns may require additional review.",
              "Policy or compliance checks can increase review time.",
            ],
          },
        ],
      },

      "ad-rejected": {
        title: "Why was my ad rejected?",
        body: [
          {
            type: "paragraph",
            text: "Advertisements may be rejected if they violate platform advertising policies or legal requirements.",
          },
          {
            type: "bullets",
            items: [
              "Misleading claims or content.",
              "Prohibited products or services.",
              "Broken or unsafe destination URLs.",
              "Low-quality or inappropriate media.",
              "Policy violations or restricted content.",
            ],
          },
          {
            type: "note",
            text: "Review the rejection reason, make the required changes, and submit the advertisement again.",
          },
        ],
      },

      "billing-when-charged": {
        title: "When do I get charged for ads?",
        body: [
          {
            type: "paragraph",
            text: "Advertising charges depend on the selected billing model and campaign settings.",
          },
          {
            type: "bullets",
            items: [
              "Charges may occur when a campaign starts.",
              "Charges may occur after advertising activity is generated.",
              "Billing schedules depend on your payment configuration.",
            ],
          },
        ],
      },

      "ad-spend-not-delivering": {
        title: "My ad is not spending or delivering. Why?",
        body: [
          {
            type: "paragraph",
            text: "A campaign may not deliver advertisements for several reasons.",
          },
          {
            type: "bullets",
            items: [
              "The campaign is still under review.",
              "The advertisement was rejected.",
              "Targeting is too restrictive.",
              "The campaign budget is too low.",
              "The campaign has been paused.",
              "There is insufficient audience reach in the selected location.",
            ],
          },
        ],
      },

      "ad-creative-best": {
        title: "What makes a good ad creative?",
        body: [
          {
            type: "paragraph",
            text: "Effective advertisements are clear, relevant, and visually engaging.",
          },
          {
            type: "bullets",
            items: [
              "Use high-quality images or videos.",
              "Keep messages simple and easy to understand.",
              "Include a clear call-to-action.",
              "Match the ad content with the destination page.",
              "Avoid excessive text or misleading claims.",
            ],
          },
        ],
      },

      refunds: {
        title: "Do you offer refunds for ads?",
        body: [
          {
            type: "paragraph",
            text: "Refund availability depends on platform policies, billing status, and the circumstances of the request.",
          },
          {
            type: "bullets",
            items: [
              "Review the applicable advertising terms.",
              "Contact support if you believe a billing error occurred.",
              "Refund requests are reviewed individually where applicable.",
            ],
          },
        ],
      },

      invoices: {
        title: "Where do I find invoices?",
        body: [
          {
            type: "paragraph",
            text: "Invoices and billing records are available in the Advertisement Manager or Billing section of your account.",
          },
          {
            type: "steps",
            items: [
              "Open Advertisement Manager.",
              "Navigate to Billing or Payments.",
              "Select Invoices.",
              "View or download available invoice documents.",
            ],
          },
        ],
      },


      ////////////////////////////////////////////////////////
      ////////////////////Troubleshooting////////////////////
      ///////////////////////////////////////////////////////

      "app-crashes": {
        title: "The app crashes or freezes. What should I do?",
        body: [
          {
            type: "paragraph",
            text: "Occasional crashes can be caused by temporary software issues, outdated versions, insufficient device resources, or network problems.",
          },
          {
            type: "steps",
            items: [
              "Close and reopen the application.",
              "Check for available updates.",
              "Restart your device.",
              "Ensure sufficient free storage space.",
              "Try again using a stable internet connection.",
            ],
          },
        ],
      },

      "cant-login": {
        title: "I can’t log in. What can cause this?",
        body: [
          {
            type: "bullets",
            items: [
              "Incorrect email address or password.",
              "Account has not been verified yet.",
              "Temporary server or network issue.",
              "Browser or application cache problems.",
              "Security restrictions due to suspicious activity.",
            ],
          },
          {
            type: "note",
            text: "If necessary, use the Forgot Password option to reset your credentials.",
          },
        ],
      },

      "slow-feed": {
        title: "The Gallery feels slow. How can I improve it?",
        body: [
          {
            type: "bullets",
            items: [
              "Check your internet connection speed.",
              "Switch between Wi-Fi and mobile data.",
              "Close unnecessary applications running in the background.",
              "Refresh the Gallery feed.",
              "Update the application to the latest version.",
            ],
          },
        ],
      },

      "no-sound": {
        title: "My video has no sound. Why?",
        body: [
          {
            type: "bullets",
            items: [
              "Your device volume may be muted.",
              "The uploaded video may not contain an audio track.",
              "Browser or device permissions may restrict audio playback.",
              "Bluetooth devices may be redirecting sound.",
              "The media file may be corrupted.",
            ],
          },
        ],
      },

      "camera-permission": {
        title: "Camera or photos permission is missing. How do I fix it?",
        body: [
          {
            type: "steps",
            items: [
              "Open your device settings.",
              "Locate Elnydo in the application list.",
              "Open Permissions.",
              "Enable Camera and Photos/Media access.",
              "Restart the application if necessary.",
            ],
          },
        ],
      },

      "location-permission": {
        title: "Location permission is missing. How do I fix it?",
        body: [
          {
            type: "steps",
            items: [
              "Open your device settings.",
              "Locate Elnydo in the application list.",
              "Open Permissions.",
              "Enable Location access.",
              "Return to the application and refresh the location.",
            ],
          },
        ],
      },

      "notifications-disabled": {
        title: "Notifications are enabled in the app but I still don’t get them.",
        body: [
          {
            type: "bullets",
            items: [
              "Check device notification settings.",
              "Disable battery optimization for Elnydo.",
              "Ensure notifications are enabled in both the app and operating system.",
              "Verify that Focus, Do Not Disturb, or Silent modes are not active.",
              "Sign out and sign in again.",
            ],
          },
        ],
      },

      "blocked-content": {
        title: "Why do I see fewer posts than my friend in the same city?",
        body: [
          {
            type: "paragraph",
            text: "The content shown in the Gallery may vary depending on account settings, moderation actions, blocked users, hidden content, location settings, and feed refresh timing.",
          },
        ],
      },

      "profile-not-updating": {
        title: "My profile changes don’t show up.",
        body: [
          {
            type: "bullets",
            items: [
              "Refresh the page or restart the application.",
              "Wait a few minutes for synchronization.",
              "Verify that the changes were saved successfully.",
              "Check your internet connection.",
              "Sign out and sign in again if the issue persists.",
            ],
          },
        ],
      },

      "contact-support-when": {
        title: "When should I contact support?",
        body: [
          {
            type: "paragraph",
            text: "Contact support if you cannot resolve an issue using the FAQ, guides, or troubleshooting steps.",
          },
          {
            type: "bullets",
            items: [
              "You cannot access your account.",
              "Payments or billing appear incorrect.",
              "A technical problem persists after troubleshooting.",
              "You suspect unauthorized account access.",
              "You need assistance with moderation, privacy, or legal requests.",
            ],
          },
          {
            type: "note",
            text: "When contacting support, provide as much detail as possible, including screenshots, error messages, and the steps that led to the issue.",
          },
        ],
      },
          }, 

  }, // closes faq

} as const;

export default faq;